<ng-container *ngIf="!isDGPBenifts">
    <section class="tw-bg-[#F7F7F7] tw-py-10 tw-px-4 lg:tw-px-20">
        <p
            class="tw-text-center sm:tw-text-left tw-text-[28px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold">
            {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.TITLE" | translate }}
        </p>
        <p class="tw-text-center sm:tw-text-left tw-py-2 tw-text-left tw-text-gray-600 tw-my-10 tw-text-[#1A202C]">
            {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.DESCRIPTION" | translate }}
        </p>

        <div class="tw-grid tw-gap-6 lg:tw-grid-cols-4 tw-grid-cols-1">
            <!-- Block 1 -->
            <div class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-min-h-[300px]">
                <img src="assets/images/icons/Finance.png" alt="Financing Options" class="tw-mx-auto tw-mb-4 tw-h-16" />
                <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING1" | translate }}
                </p>
                <p class="tw-text-black-600">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION1" | translate }}
                </p>
            </div>

            <!-- Block 2 -->
            <div class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center">
                <img src="assets/images/icons/Process.png" alt="Seamless Application"
                    class="tw-mx-auto tw-mb-4 tw-h-16" />
                <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING2" | translate }}
                </p>
                <p class="tw-text-black-600">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION2" | translate }}
                </p>
            </div>

            <!-- Block 3 -->
            <div class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center">
                <img src="assets/images/icons/Wallet.png" alt="Trusted Partners" class="tw-mx-auto tw-mb-4 tw-h-16" />
                <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING3" | translate }}
                </p>
                <p class="tw-text-black-600">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION3" | translate }}
                </p>
            </div>

            <!-- Block 4 -->
            <div class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center">
                <img src="assets/images/icons/Calculator.png" alt="Smart Tools" class="tw-mx-auto tw-mb-4 tw-h-16" />
                <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING4" | translate }}
                </p>
                <p class="tw-text-black-600">
                    {{ "NEW_PRODUCTS.BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION4" | translate }}
                </p>
            </div>
        </div>
    </section>
</ng-container>
<ng-container *ngIf="isDGPBenifts">
    <section class="tw-bg-[#F7F7F7] tw-py-10 tw-px-4 lg:tw-px-20">
        <p
            class="tw-text-center sm:tw-text-left tw-text-[28px] md:tw-text-[40px] tw-w-full tw-text-[#0F3172] tw-font-bold">
            {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.TITLE" | translate }}
        </p>
        <p class="tw-text-center sm:tw-text-left tw-py-2 tw-text-left tw-text-gray-600 tw-my-10 tw-text-[#1A202C]">
            {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.DESCRIPTION" | translate }}
        </p>

        <div class="tw-flex tw-justify-center">
            <div class="tw-grid tw-gap-6 lg:tw-grid-cols-3 tw-grid-cols-1 tw-max-w-[60rem]">
                <!-- Block 1 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-min-h-[280px] tw-flex tw-flex-col tw-justify-center">
                    <img src="assets/images/icons/Finance.png" alt="Financing Options"
                        class="tw-mx-auto tw-mb-4 tw-h-16" />
                    <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING1" | translate }}
                    </p>
                    <p class="tw-text-black-600">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION1" | translate }}
                    </p>
                </div>

                <!-- Block 2 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-min-h-[280px] tw-flex tw-flex-col tw-justify-center">
                    <img src="assets/images/icons/Process.png" alt="Seamless Application"
                        class="tw-mx-auto tw-mb-4 tw-h-16" />
                    <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING2" | translate }}
                    </p>
                    <p class="tw-text-black-600">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION2" | translate }}
                    </p>
                </div>

                <!-- Block 3 -->
                <div
                    class="tw-bg-white tw-rounded-2xl tw-shadow-lg tw-p-7 tw-text-center tw-min-h-[280px] tw-flex tw-flex-col tw-justify-center">
                    <img src="assets/images/icons/Wallet.png" alt="Trusted Partners"
                        class="tw-mx-auto tw-mb-4 tw-h-16" />
                    <p class="tw-font-bold tw-text-lg tw-mb-2 tw-text-[20px]">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING3" | translate }}
                    </p>
                    <p class="tw-text-black-600">
                        {{ "NEW_PRODUCTS.DGP_BUSINESS_FINANCING_BENEFITS.HEADING_DESCRIPTION3" | translate }}
                    </p>
                </div>
            </div>
        </div>
    </section>
</ng-container>